import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import PageLayout from './components/PageLayout';
import HeroSection from './components/HeroSection';
import WhoWeAre from './components/WhoWeAre';
import ServicesBar from './components/ServicesBar';
import LookingForSupport from './components/LookingForSupport';
import UrbanAngelsSection from './components/UrbanAngelsSection';
import PartnershipsCarousel from './components/PartnershipsCarousel';
import IfysStoryPage from './pages/our-story/IfysStoryPage';
import OurPeoplePage from './pages/our-story/OurPeoplePage';
import SanctuaryPage from './pages/our-story/SanctuaryPage';
import IfysServicesPage from './pages/services/IfysServicesPage';
import YouthServicesPage from './pages/services/YouthServicesPage';
import ChildProtectionPage from './pages/services/ChildProtectionPage';
import DisabilityServicesPage from './pages/services/DisabilityServicesPage';
import ChildFamilyServicesPage from './pages/services/ChildFamilyServicesPage';
import HousingAccommodationPage from './pages/services/HousingAccommodationPage';
import SocialEnterprisesPage from './pages/services/SocialEnterprisesPage';
import IfysRecruitmentPage from './pages/employment/IfysRecruitmentPage';
import CurrentVacanciesPage from './pages/employment/CurrentVacanciesPage';
import VolunteersPage from './pages/employment/VolunteersPage';
import DonationsAtIfysPage from './pages/donations/DonationsAtIfysPage';
import PartnerWithUsPage from './pages/partnerships/PartnerWithUsPage';
import ContactIfysPage from './pages/contact/ContactIfysPage';
import ContactThankYouPage from './pages/contact/ContactThankYouPage';
import NotFoundPage from './pages/NotFoundPage';

function HomePage() {
  return (
    <PageLayout activeLink="home">
      <HeroSection />
      <WhoWeAre />
      <ServicesBar />
      <LookingForSupport />
      <UrbanAngelsSection />
      <PartnershipsCarousel />
    </PageLayout>
  );
}

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    const prefersReducedMotion = document.documentElement.classList.contains('reduced-motion');
    const behavior = prefersReducedMotion ? 'auto' : 'smooth';

    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior });
      return;
    }

    const id = location.hash.slice(1);
    const el = document.getElementById(id);
    if (!el) return;

    // Defer one tick so layouts (and images) have a chance to render.
    const t = setTimeout(() => {
      el.scrollIntoView({ behavior, block: 'start' });
    }, 0);
    return () => clearTimeout(t);
  }, [location.hash, location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <>
        <ScrollToHash />
        <a href="#content-start" className="skip-link">
          Skip to main content
        </a>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-story/ifys-story" element={<IfysStoryPage />} />
          <Route path="/our-story/our-people" element={<OurPeoplePage />} />
          <Route path="/our-story/sanctuary" element={<SanctuaryPage />} />
          <Route path="/services/ifys-services" element={<IfysServicesPage />} />
          <Route path="/services/youth-services" element={<YouthServicesPage />} />
          <Route path="/services/child-protection" element={<ChildProtectionPage />} />
          <Route path="/services/disability-services" element={<DisabilityServicesPage />} />
          <Route path="/services/child-and-family-services" element={<ChildFamilyServicesPage />} />
          <Route path="/services/housing-and-accommodation" element={<HousingAccommodationPage />} />
          <Route path="/services/social-enterprises" element={<SocialEnterprisesPage />} />
          <Route path="/employment/ifys-recruitment" element={<IfysRecruitmentPage />} />
          <Route path="/employment/current-vacancies" element={<CurrentVacanciesPage />} />
          <Route path="/employment/volunteers" element={<VolunteersPage />} />
          <Route path="/donations/donations-at-ifys" element={<DonationsAtIfysPage />} />
          <Route path="/partnerships/partner-with-us" element={<PartnerWithUsPage />} />
          <Route path="/contact/contact-ifys" element={<ContactIfysPage />} />
          <Route path="/contact/contact-ifys/thank-you" element={<ContactThankYouPage />} />
          {/* Legacy CMS URL redirects */}
          <Route path="/contact/compliments-and-feedback" element={<Navigate to="/contact/contact-ifys" replace />} />
          <Route path="/contact/compliments-and-feedback/" element={<Navigate to="/contact/contact-ifys" replace />} />
          <Route path="/vacancies/vacancies.html" element={<Navigate to="/employment/current-vacancies" replace />} />
          <Route path="/vacancies" element={<Navigate to="/employment/current-vacancies" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
